/**
 * ModuleAbsentState — the clean "non disponible sur cette installation" panel. QC is a local module,
 * but a build may not have its routes mounted (or predates 08): a probe then 404s / 501s. Rather than a
 * hard error, the screen renders this neutral, reassuring state (glyph + text, not color-only). It is
 * NOT the sans-droit path (that's ForbiddenState) nor a transport error (that's ErrorState).
 */
import { EmptyState } from "@/ui";
import { useT } from "@/app";

export function ModuleAbsentState() {
  const { t } = useT();
  return <EmptyState glyph="⌧" title={t("qc.absent.title")} description={t("qc.absent.desc")} />;
}
